// Chromium / Firefox / WebKit phrasings for a dynamic import() whose chunk couldn't be fetched.
const STALE_CHUNK_PATTERN =
    /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;

export function isStaleChunkError(message: string): boolean {
    return STALE_CHUNK_PATTERN.test(message);
}
